'use strict';

import moment from "moment";

const START_TIMESLOT = "08:00";
const END_TIMESLOT = "20:00";
const TIMESLOT_INTERVAL = 30;

function roundToLast30Minutes(date) {
  var ROUNDING = 30 * 60 * 1000;
  return moment(Math.floor((+date) / ROUNDING) * ROUNDING);
}
function createTimeSlots(date) {
  let startTimeSlot = date
    .clone()
    .hours(START_TIMESLOT.split(":")[0])
    .minutes(START_TIMESLOT.split(":")[1]);
  let lastTimeSlot = date
    .clone()
    .hours(END_TIMESLOT.split(":")[0])
    .minutes(END_TIMESLOT.split(":")[1]);

  let timeslots = [];
  let offset = roundToLast30Minutes(date.clone().add(1.5, "hours"));
  while (startTimeSlot.isBefore(lastTimeSlot)) {
    if (startTimeSlot.isAfter(offset)) {
      timeslots.push(
        startTimeSlot.format("HH:mm") + " - " +
        startTimeSlot.add(TIMESLOT_INTERVAL, "minutes").format("HH:mm")
      );
    } else {
      startTimeSlot.add(TIMESLOT_INTERVAL, "minutes")
    }
  }
  return timeslots;
}

export { createTimeSlots };